import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';
import {SensorComponent} from './sensor.component';
import {SensorsRoutesEnum} from './services/navigation/sensors-routes.enum';
import {SensorsListComponent} from './sensors-list/sensors-list.component';
import {BatchCreateSensorComponent} from './batch-create-sensor/batch-create-sensor.component';

const routes: Routes = [
  {
    path: RoutesEnum.SENSORS,
    component: SensorComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path:
        SensorsRoutesEnum.LIST,
        component: SensorsListComponent,
      },
      {
        path: SensorsRoutesEnum.BATCH_CREATE,
        component: BatchCreateSensorComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule],
})
export class SensorRoutingModule {
}
